const Biz =
{
  biz1: 
  {
    id          : 1,
    location    : 
    [
      -0.163566,
      -78.486285
    ],
    info        :
    {
      name          : "PMJ Arquitectos",    
      username      : "pmjarquitectos",
      type          : 'builder',
      subtype       : 'civil',
      cateregories  : []
    },
    links        :
    {
      instagram   : 'pmjarquitectosec',
      tiktok      : 'pmjarquitectos',
      facebook    : 'pmjArquitectura',
      webpage     : 'http://www.pmjarquitectos.com',
      whatsapp    : '+593985323724',
    },
    gps         :
    {
      google    : true,
      waze      : true,
      gsv         : 'gNx9q7mf5Uhmt5KS7'
    },
    images     : 
    {
      main        : 'https://firebasestorage.googleapis.com/v0/b/fair360.appspot.com/o/panoramas%2Ftour%2Fv01%2Fpano-(11).jpg?alt=media&token=81cc0d73-3deb-4e81-a510-bdf0fb9736b0',
      is360       : true,
      thumbnail   : 'https://firebasestorage.googleapis.com/v0/b/construvisor.appspot.com/o/propuesta%2Fpmjarquitectos.png?alt=media&token=424a8b52-94dd-4b1b-8511-410f5a9f374d',
      thumbnailPlaceholder   : 'https://firebasestorage.googleapis.com/v0/b/construvisor.appspot.com/o/propuesta%2Fpmjarquitectos.png?alt=media&token=424a8b52-94dd-4b1b-8511-410f5a9f374d',
    },
  },
  biz2: 
  {
    id          : 2,
    location    : 
    [
      -0.1012484,
      -78.440817
    ],
    info        :
    {
      name          : "Light It Be",    
      username      : "lightitbe",
      type          : 'design',
      subtype       : 'illumination',
      cateregories  : []
    },
    links        :
    {
      instagram   : 'lightitbe',
      tiktok      : 'lightitbe',
      facebook    : 'lightitbe',
      webpage     : 'http://www.lightitbe.com',
      whatsapp    : '+593985323724',
    },
    gps         :
    {
      google    : true,
      waze      : true,
      gsv       : 'gNx9q7mf5Uhmt5KS7'
    },
    images     : 
    {
      main        : 'https://firebasestorage.googleapis.com/v0/b/fair360.appspot.com/o/panoramas%2Ftour%2Fv01%2Fpano-(11).jpg?alt=media&token=81cc0d73-3deb-4e81-a510-bdf0fb9736b0',
      is360       : true,
      thumbnail   : 'https://firebasestorage.googleapis.com/v0/b/construvisor.appspot.com/o/propuesta%2Flightitbe.jpg?alt=media&token=d9be6122-ce7a-4a3f-8a8b-ea5f76c1534e',
      thumbnailPlaceholder   : 'https://firebasestorage.googleapis.com/v0/b/construvisor.appspot.com/o/propuesta%2Flightitbe.jpg?alt=media&token=d9be6122-ce7a-4a3f-8a8b-ea5f76c1534e',
    },
  },
  biz3: 
  {
    id          : 3,
    location    : 
    [
      -0.1804004,
      -78.4750485
    ],
    info        :
    {
      name          : 'ARBU Constructora',    
      username      : "arbuconstructora",
      type          : 'builder',
      subtype       : 'civil',
      cateregories  : []
    },
    links        :
    {
      instagram   : 'arbuconstructora',
      tiktok      : 'arbuconstructora',
      facebook    : 'arbuconstructora',
      webpage     : 'http://www.arbuconstructora.com',
      whatsapp    : '+593985323724',
    },
    gps         :
    {
      google    : true,
      waze      : true,
      gsv       : 'r2kLYCwJdtrPY84f6'
    },
    images     : 
    {
      main        : 'https://firebasestorage.googleapis.com/v0/b/fair360.appspot.com/o/panoramas%2Ftour%2Fv01%2Fpano-(11).jpg?alt=media&token=81cc0d73-3deb-4e81-a510-bdf0fb9736b0',
      is360       : true,
      thumbnail   : 'https://firebasestorage.googleapis.com/v0/b/construvisor.appspot.com/o/propuesta%2Farbuconstructora.jpg?alt=media&token=8af8c165-7875-4ed5-bb2f-04df3ad8d7c6',
      thumbnailPlaceholder   : 'https://firebasestorage.googleapis.com/v0/b/construvisor.appspot.com/o/propuesta%2Farbuconstructora.jpg?alt=media&token=8af8c165-7875-4ed5-bb2f-04df3ad8d7c6',
    },
  },
  biz4: 
  {
    id          : 4,
    location    : 
    [
      -0.1846106,
      -78.4790018
    ],
    info        :
    {
      name          : 'Javier Hernández',
      username      : "entornoceo",
      type          : 'ingeniero',
      subtype       : 'estructural',
      cateregories  : []
    },
    links        :
    {
      instagram   : 'entornoceo',
      tiktok      : 'viveen360',
      facebook    : 'entornoceo',
      webpage     : 'http://www.aportevial.com',
      whatsapp    : '+593985323724',
    },
    gps         :
    {
      google    : true,
      waze      : true,
      gsv       : 'r2kLYCwJdtrPY84f6'
    },
    images     : 
    {
      main        : 'https://firebasestorage.googleapis.com/v0/b/fair360.appspot.com/o/panoramas%2Ftour%2Fv01%2Fpano-(11).jpg?alt=media&token=81cc0d73-3deb-4e81-a510-bdf0fb9736b0',
      is360       : true,
      thumbnail   : 'https://firebasestorage.googleapis.com/v0/b/construvisor.appspot.com/o/propuesta%2Fentornoceo.jpg?alt=media&token=8c0b7870-2106-485f-b291-94afddb6aea9',
      thumbnailPlaceholder   : 'https://firebasestorage.googleapis.com/v0/b/construvisor.appspot.com/o/propuesta%2Fentornoceo.jpg?alt=media&token=8c0b7870-2106-485f-b291-94afddb6aea9',
    },
  },
}

export default Biz;